function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#FFF"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M14.707 5.876c.645-.761 1.078-1.82.96-2.876-.926.036-2.052.605-2.715 1.364-.594.675-1.116 1.751-.977 2.785 1.034.078 2.09-.513 2.732-1.273M19.5 16.203c-.023.062-.388 1.292-1.277 2.559-.766 1.097-1.564 2.192-2.82 2.213-1.232.024-1.628-.714-3.039-.714-1.41 0-1.85.693-3.017.738-1.213.046-2.133-1.186-2.908-2.278-1.584-2.235-2.79-6.317-1.17-9.069.808-1.368 2.248-2.233 3.812-2.256 1.192-.02 2.314.782 3.041.782.728 0 2.09-.97 3.526-.827.599.027 2.286.237 3.37 1.786-.09.055-2.013 1.147-1.992 3.425.024 2.724 2.446 3.63 2.474 3.641",
  transform: "translate(-86 -456) translate(0 -237) translate(0 420) translate(24 188) translate(0 73) translate(62 12)"
}))))))));

var SvgAppleIcon = function SvgAppleIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAppleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/apple_icon.6a714c0d.svg";
export { ForwardRef as ReactComponent };